/**
 * Resolve screening/event titles for display and export.
 * UI language first, then instance default language, then original / first value.
 */

function normalizeLang(lang) {
    if (!lang || typeof lang !== 'string')
        return '';
    return lang.split(/[-_]/)[0].toLowerCase();
}

function titleLangValue(titles, lang) {
    if (!titles || typeof titles !== 'object' || Array.isArray(titles))
        return '';

    const value = titles[lang];
    if (typeof value !== 'string')
        return '';

    const trimmed = value.trim();
    return trimmed || '';
}

function titlesWithOriginal(titles, externalOriginal) {
    if (!titles || typeof titles !== 'object' || Array.isArray(titles))
        titles = {};

    if (externalOriginal == null || externalOriginal === '')
        return titles;

    return { ...titles, original: externalOriginal };
}

export function resolveEventTranslatedTitle(titles, uiLang, defaultLang) {
    const normalizedUi = normalizeLang(uiLang);
    const fromUi = titleLangValue(titles, normalizedUi);
    if (fromUi)
        return fromUi;

    const normalizedDefault = normalizeLang(defaultLang);
    if (normalizedDefault && normalizedDefault !== normalizedUi) {
        const fromDefault = titleLangValue(titles, normalizedDefault);
        if (fromDefault)
            return fromDefault;
    }

    const original = titleLangValue(titles, 'original');
    if (original)
        return original;

    for (const key of Object.keys(titles)) {
        if (key === 'original')
            continue;
        const value = titleLangValue(titles, key);
        if (value)
            return value;
    }

    return '';
}

export function resolveEventTitleDisplay(titles, uiLang, defaultLang, externalOriginal) {
    const merged = titlesWithOriginal(titles, externalOriginal);
    const original = titleLangValue(merged, 'original');
    const translated = resolveEventTranslatedTitle(merged, uiLang, defaultLang);
    const main = translated || original || '';
    const hasSubtitle = !!(main && original && main !== original);

    return {
        main,
        subtitle: hasSubtitle ? original : '',
        hasSubtitle,
    };
}

export function eventTitleExportPair(titles, uiLang, defaultLang, externalOriginal) {
    const merged = titlesWithOriginal(titles, externalOriginal);
    const original = titleLangValue(merged, 'original');
    const translated = resolveEventTranslatedTitle(merged, uiLang, defaultLang);

    return {
        translated: translated || original || '',
        original: original || translated || '',
    };
}
